import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const { sectionLabel } = this.props;
    console.error(`Renderfehler in Bereich "${sectionLabel || 'Unbekannt'}"`, error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    const { hasError } = this.state;
    const { children, COLORS, sectionLabel } = this.props;

    if (!hasError) return children;

    return (
      <div
        style={{
          padding: '18px',
          borderRadius: '16px',
          border: `1px solid ${COLORS.red}55`,
          background: COLORS.card,
          boxShadow: '0 12px 30px rgba(0,0,0,0.14)',
        }}
      >
        <div style={{ color: COLORS.red, fontWeight: '700', marginBottom: '8px' }}>
          Dieser Bereich konnte gerade nicht geladen werden.
        </div>
        <div style={{ color: COLORS.muted, fontSize: '14px', lineHeight: 1.7, marginBottom: '14px' }}>
          Betroffen ist: <strong style={{ color: COLORS.text }}>{sectionLabel || 'Unbekannt'}</strong>.
          {' '}Die restliche App bleibt nutzbar. Du kannst den Bereich direkt erneut versuchen.
        </div>
        <button
          onClick={this.handleRetry}
          style={{
            background: COLORS.accent,
            color: '#fff',
            border: 'none',
            borderRadius: '10px',
            padding: '10px 16px',
            fontSize: '13px',
            fontWeight: '700',
            cursor: 'pointer',
          }}
        >
          Bereich neu laden
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
